import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { GeneratePdf, GeneratePdfParameter, GeneratePdfResultModel } from "@tSurya/Services/GeneratePdfService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type GeneratePdfParameterParam = HasOnSuccess<BlobPart> & GeneratePdfParameter & HasOnError;

type HandlerType = CustomApiHandler<GeneratePdfParameterParam, BlobPart>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await GeneratePdf(props.apiParameter)) as unknown as BlobPart;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        const blob = new Blob([props.apiResult], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        const sanitizeFileName = (name: string): string =>
            name
                .normalize("NFKC")
                .replace(/["“”‘’«»]/g, "")
                .replace(/[<>:/\\|?*]/g, "_")
                .replace(/\s+/g, " ")
                .trim();

        const filename = sanitizeFileName(
            `${props.apiParameter.brandName || ""} ${props.apiParameter.CollectionName || ""} ${props.apiParameter.identifier}.pdf`,
        );
        link.href = url;
        link.download = filename || "download.pdf";
        link.click();
        window.URL.revokeObjectURL(url);

        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const generatePdf = createHandlerChainRunner(chain, "GeneratePdf");
export default generatePdf;
